/**
  *  @fileOverview: 首页-数据统计
  *  @creator: CaoYanqi
  *  @Date: 2019/6/5
  *  @Last Modified by: 
  *  @Last Modified time:
  */
import { Button, Modal, Table } from 'antd';
import * as React from 'react';
import { connect } from 'react-redux';
import { axios_ } from "../../../tools/axios_";
import { desensitizeName } from '../../../tools/utils';
import './dataCount.less';
const columns = [
    {
        title: '日期',
        dataIndex: 'key',
        key: 'key',
    },
    {
        title: '保单数',
        dataIndex: 'policyNum',
        key: 'policyNum',
    },
    {
        title: '保费（元）',
        dataIndex: 'premium',
        key: 'premium',
    },
]
const columns2 = [
    {
        title: '投保人',
        dataIndex: 'holderName',
        key: 'holderName',
        render:(text,record) => <span>{desensitizeName(text)}</span>
    },
    {
        title: '保费（元）',
        dataIndex: 'premium',
        key: 'premium',
    },
]
class KeyProducts extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
        data1:[],
        data2:[],
        data3: [],
        data4: [],
        data5: [],
        data6: [],
        isModalOpen: false,
        total: 0,
        current:1,
        pageSize:6,
        curSpuId: ''
    }

  }

  componentDidMount() {
    this.hetaiStatistics('1982717310108688384');
  }
  hetaiStatistics=(spuId)=>{
    axios_({
      url:`/api/insurepolicy/platform/policy/hetaiStatistics?&spuId=${spuId}`,
      methods:"get",
      headers: {
        'access-token': this.props.token
      }
    }).then(res=>{
      if(res.status===200){
        if(spuId ==='1982717310108688384') {
            let data1= [
                {
                  key: '今日',
                  policyNum: res.data.data.dayPolicys,
                  premium: res.data.data.dayPremium
                },
                {
                    key: '本月',
                    policyNum: res.data.data.monthPolicys,
                    premium: res.data.data.monthPremium
                },
                {
                    key: '总计',
                    policyNum: res.data.data.totalPolicys,
                    premium: res.data.data.totalPremium
                }
            ]
            this.setState( {
                data1
            })
        }
      }
    })
  };
  doSee=(spuId)=>{
    axios_({
        url:'/api/insurepolicy/platform/policy/holder',
          method:'post',
          data:{
            spuId,
            pageNum: this.state.current,
            pageSize: this.state.pageSize
          },
          headers: {
            'access-token': this.props.token
          }
        }).then(res=>{
          if(res.data.code===0){
            this.setState({
                isModalOpen: true,
                curSpuId: spuId,
                data3: res.data.data.dataList,
                total: res.data.data.pageInfo.total
            })
          }
        })
 }
 onChange = (current,pageSize)=>{
    this.setState({
        current,
        pageSize
    },()=>{
        this.doSee(this.state.curSpuId)
    })
 }
  /**
     * 控制每页展示的条数
     * @param current   当前页数
     * @param pageSize  每页展示多少条
     */
  onShowSizeChange = (current, pageSize) => {
    this.setState({
        pageSize,
        current: 1//将当前页数恢复为1
    }, () => {
        this.doSee(this.state.curSpuId)
    });
};
  render() {
    return (
      <div className="data_count_wrap" style={{ minHeight: 130 }}>
        <div style={{display:'flex','flex-wrap': 'wrap'}}>
            <div style={{'width':'45%', margin:'0 10px',position:'relative',paddingBottom:50}}>
                <p style={{marginBottom:10,textAlign:'center'}}>小太阳2号高保额少儿防癌险（互联网）</p>
                <Table columns={columns} dataSource={this.state.data1}  pagination={false}/>
                <Button className="expand_btn"  type="text" onClick={index => {
                    this.setState({
                        current:1
                    },()=>{
                        this.doSee('1982717310108688384');
                    })
                }}>查看详情</Button>
            </div>
        </div>
        <Modal title={`查看详情--小太阳2号高保额少儿防癌险（互联网）`} bodyStyle={{ height: '500px', overflow: 'auto' }} open={this.state.isModalOpen} footer={null} onCancel={() => this.setState({isModalOpen: false})}>
            {
                this.state.isModalOpen && <Table columns={columns2} dataSource={this.state.data3} pagination={{
                    size:"small",
                    onChange: (current, pageSize) => {
                      this.onChange(current,pageSize)
                    },
                    defaultPageSize: this.state.pageSize,
                    total: this.state.total,
                    current: this.state.current,
                    showTotal: (total, range) => `共${total} 条`,
                    showSizeChanger: true,
                    onShowSizeChange: this.onShowSizeChange
                  }}/>
            }

        </Modal>
      </div>
    )
  }
}

function mapState(state) {
  return {
    token: state.token
  }
}

export default connect(mapState)(KeyProducts)
